"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateChartData = void 0;
const AmountField_1 = require("components/QuickenControls/AmountField");
const generateChartData = (totalSpendings, annualBudget, totalSavings, currency, theme, amountFormat) => {
    var _a, _b, _c, _d;
    const chartData = [];
    let annualBudgetForCalculation = annualBudget;
    if (totalSpendings < annualBudget) {
        chartData.push({
            from: ((_a = chartData[chartData.length - 1]) === null || _a === void 0 ? void 0 : _a.to) || 0,
            to: totalSpendings,
            value: totalSpendings,
            label: '',
            fill: theme.components.progressChart.primaryColor,
            graphValue: Number((0, AmountField_1.formatNumber)(totalSpendings, '', amountFormat)) === 0 ? '' : (0, AmountField_1.formatNumber)(totalSpendings, currency, amountFormat),
        }, {
            from: totalSpendings,
            to: annualBudget,
            value: annualBudget,
            label: '',
            fill: theme.components.progressChart.secondaryColor,
            graphValue: '',
        });
    }
    else {
        annualBudgetForCalculation = totalSpendings - annualBudget;
        chartData.push({
            from: ((_b = chartData[chartData.length - 1]) === null || _b === void 0 ? void 0 : _b.to) || 0,
            to: annualBudget,
            value: annualBudget,
            label: '',
            fill: theme.components.progressChart.primaryColor,
            graphValue: Number((0, AmountField_1.formatNumber)(annualBudget, '', amountFormat)) === 0 ? '' : (0, AmountField_1.formatNumber)(annualBudget, currency, amountFormat),
        }, {
            from: annualBudget,
            to: annualBudget + annualBudgetForCalculation,
            value: totalSpendings,
            label: '',
            fill: theme.components.progressChart.dangerColor,
            graphValue: '',
        });
    }
    chartData.push({
        from: ((_c = chartData[chartData.length - 1]) === null || _c === void 0 ? void 0 : _c.to) || 0,
        to: (((_d = chartData[chartData.length - 1]) === null || _d === void 0 ? void 0 : _d.to) || 0) + totalSavings,
        value: totalSavings,
        label: '',
        fill: theme.components.progressChart.fillColor,
        graphValue: '',
    });
    return chartData;
};
exports.generateChartData = generateChartData;
